import { useMediaQuery } from '@mantine/hooks';

type IsMobile = { isMobile: boolean | undefined };

export function useIsMobile(): IsMobile {
  const isMobile = useMediaQuery('(max-width: 48em)');
  return { isMobile };
}
